/**
 * Earn Types
 */

export type SubmissionStatus = 'pending' | 'approved' | 'rejected'

export interface Opportunity {
    id: string
    title: string
    description: string
    type_id: string
    company: string
    company_logo?: string
    location: string
    location_type: 'remote' | 'onsite' | 'hybrid' | 'none'
    compensation?: string
    url: string
    tags: string[]
    featured: boolean
    deadline?: string | null
    created_at: string
    status?: SubmissionStatus
    submitted_by?: string | null
    submitted_by_name?: string
    reviewed_by?: string | null
    reviewed_at?: string | null
    priority?: number | null
}

export interface OpportunityTypeInfo {
    id: string
    label: string
    icon: string
    color: string
    active: boolean
    sort_order?: number
}

export type OpportunityType = string

export const OPPORTUNITY_TYPES: Record<OpportunityType, { label: string; icon: string; color: string }> = {
    'job': { label: 'Job', icon: 'pi-briefcase', color: '#0077ff' },
    'grant': { label: 'Grant', icon: 'pi-wallet', color: '#10b981' },
    'bounty': { label: 'Bounty', icon: 'pi-bolt', color: '#f59e0b' },
    'gig': { label: 'Gig', icon: 'pi-clock', color: '#8b5cf6' },
    'referral': { label: 'Referral', icon: 'pi-users', color: '#ec4899' },
    'airdrop': { label: 'Airdrop', icon: 'pi-gift', color: '#06b6d4' },
    'staking': { label: 'Staking', icon: 'pi-percentage', color: '#10b981' },
}

export const SAMPLE_OPPORTUNITIES: Opportunity[] = [
    {
        id: '1',
        title: 'Smart Contract Developer',
        description: 'Looking for an experienced Solidity developer to build DeFi protocols.',
        type_id: 'job',
        company: 'DeFi Labs',
        location: 'Remote',
        location_type: 'remote',
        compensation: '$120k - $180k',
        url: 'https://jobs.example.com/1',
        tags: ['Solidity', 'DeFi', 'Full-time'],
        featured: true,
        created_at: new Date().toISOString(),
    },
    {
        id: '2',
        title: 'AI Integration Bounty',
        description: 'Build an AI-powered trading bot using our API. $5,000 prize pool.',
        type_id: 'bounty',
        company: 'Trading Protocol',
        location: 'Remote',
        location_type: 'remote',
        compensation: '$5,000',
        url: 'https://bounty.example.com/2',
        tags: ['AI', 'Trading', 'Python'],
        featured: true,
        deadline: '2026-03-01',
        created_at: new Date().toISOString(),
    },
    {
        id: '3',
        title: 'Community Growth Grant',
        description: 'Apply for funding to grow crypto communities in your region.',
        type_id: 'grant',
        company: 'Crypto Foundation',
        location: 'Worldwide',
        location_type: 'remote',
        compensation: 'Up to $50,000',
        url: 'https://grants.example.com/3',
        tags: ['Community', 'Marketing'],
        featured: false,
        deadline: '2026-02-15',
        created_at: new Date().toISOString(),
    },
]
